import { Alert, Box, Container } from '@mui/material';
import React from 'react';

export default function Error({ error }) {
  return (
    <Container component="main" className="layout-main" maxWidth={false} disableGutters>
      <Box className="wrapper" role="main" aria-label="Die Seite wird geladen">
        <Container>
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        </Container>
      </Box>
    </Container>
  );
}
